import React from 'react';
import { Helmet } from 'react-helmet';
import { Wrapper } from '@magoosh/gre/adaptive_prep_v1/lib/wrapper';
import { PageCard } from '@magoosh/gre/adaptive_prep_v1/lib/page_card';
import Tabs from '@magoosh/gre/adaptive_prep_v1/lib/tabs';
import RegistrationFormModal from '../organisms/registration_form_modal';
import { YourClassesProvider } from './context';
import { UserProvider } from '@magoosh/context/user_context';
import RecentContent from './tabs/recent_content';
import RegisteredContent from './tabs/registered_content';
import UpcomingContent from './tabs/upcoming_content';

interface Props {
  helpPageLink?: string;
  descriptionHtml?: string;
}

export const YourClassesPage: React.FC<Props> = (props) => {
  return (
    <Wrapper>
      <Helmet>
        <title>Classes</title>
      </Helmet>

      <PageCard>
        <h2 className="u-margin-A-n">
          <strong>Classes</strong>
        </h2>
        {props.helpPageLink && (
          <p>
            <a href={props.helpPageLink}>Learn more about live classes</a>
          </p>
        )}

        {props.descriptionHtml && <div dangerouslySetInnerHTML={{ __html: props.descriptionHtml }} />}

        <UserProvider>
          <YourClassesProvider>
            <Tabs defaultTab="upcoming">
              <hr className="u-margin-B-xs" />
              <div className="text-center">
                <Tabs.Tab tab="upcoming">Upcoming Classes</Tabs.Tab>
                <Tabs.Tab tab="recent">Recent Recordings</Tabs.Tab>
                <Tabs.Tab tab="registered">Your Classes</Tabs.Tab>
              </div>
              <hr className="u-margin-T-xs" />

              <Tabs.Panel tab="upcoming">
                <UpcomingContent />
              </Tabs.Panel>

              <Tabs.Panel tab="recent">
                <RecentContent />
              </Tabs.Panel>

              <Tabs.Panel tab="registered">
                <RegisteredContent />
              </Tabs.Panel>
            </Tabs>
            <RegistrationFormModal />
          </YourClassesProvider>
        </UserProvider>
      </PageCard>
    </Wrapper>
  );
};

export default YourClassesPage;
